import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';
import React from 'react';
import { Grid, Row, Col } from 'rsuite';

const Screening = ({
  heading,
  card1Title,
  card2title,
  card3Title,
  card1Detail,
  card2Detail,
  card3Detail,
  card1img,
  card2img,
  card3img,
  bg,
  spacing,
}) => {
  return (
    <div>
      <div className="container-fluid   px-lg-0 ">
        <HeadingSection spacing={spacing} title={heading} bgcolor="white" />

        <div className="lg:container px-xl-5 pt-4 mx-auto">
          <div className="row gx-lg-5 ">
            <Grid>
              <Row>
                <Col xs={24} md={8} >
                  <div className="col-lg-4 col-sm-6 mb-4 mb-md-0">
                    <div className="card bg-transparent border-0">
                      <div className="  text-center ">
                        {card1Title && (
                          <p
                            className="fs-24-30 fontWeight mb-lg-4 mb-3   "
                            style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                            {card1Title}
                          </p>
                        )}
                      </div>

                      <img loading="lazy" src={card1img} className=" img img-fluid rounded-0 card-img-top" alt="..." />

                      <div className="card-body p-0  pb-2">
                        <div
                          className="card-title d-flex flex-lg-row 
                                flex-column justify-content-between text-center mt-3 mb-0 mb-md-4 pb-0 pb-md-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                          <p className="fs-18-27 fw-400">{card1Detail}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={8} >
                  <div className="col-lg-4 col-sm-6 mb-4 mb-md-0">
                    <div className="card bg-transparent border-0">
                      <div className="  text-center">
                        {card2title && (
                          <p
                            className="fs-24-30 fontWeight mb-3 mb-lg-4  "
                            style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                            {card2title}
                          </p>
                        )}
                      </div>

                      <img loading="lazy" src={card2img} className=" img img-fluid rounded-0 card-img-top" alt="..." />

                      <div className="card-body p-0  pb-2">
                        <div
                          className="card-title d-flex flex-lg-row 
                            flex-column justify-content-between text-center mt-3 mb-0 mb-md-4 pb-0 pb-md-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                          <p className="fs-18-27 fw-400">{card2Detail}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={8} >
                  <div className="col-lg-4 col-sm-6 mb-4 mb-md-0 ">
                    <div className="card bg-transparent border-0">
                      <div className="  text-center">
                        {card3Title && (
                          <p
                            className="fs-24-30 fontWeight mb-lg-4 mb-3  "
                            style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                            {card3Title}
                          </p>
                        )}
                      </div>

                      <img loading="lazy" src={card3img} className=" img img-fluid rounded-0 card-img-top" alt="..." />

                      <div className="card-body p-0  pb-2">
                        <div
                          className="card-title d-flex flex-lg-row
                              flex-column justify-content-between  text-center
                              mt-3 mb-4 pb-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                          <p className="fs-18-27 fw-400">{card3Detail}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
      <Styles/>
    </div>
  );
};

export default Screening;
